<template>
    <v-app>
        <div class="col-md-10 mt-30 mx-auto">
            <!--add new category-->
            <template>
                <v-row justify="center">
                    <v-dialog
                            v-model="addNewCategory"
                            max-width="900"
                            hide-overlay
                            transition="dialog-bottom-transition"
                    >
                        <v-card>
                            <v-toolbar
                                    dark
                                    color="primary"
                            >
                                <v-toolbar-title>ایجاد دسته</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn
                                            icon
                                            dark
                                            @click="addNewCategory = false"
                                    >
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </v-toolbar-items>
                            </v-toolbar>
                            <div>
                                <create-category :modal="()=>{this.addNewCategory = false}"
                                                 :parent_id="parent_id"></create-category>
                            </div>
                        </v-card>
                    </v-dialog>
                </v-row>
            </template>
            <!--add new category-->

            <!--edit category-->
            <template>
                <v-row justify="center">
                    <v-dialog
                            v-model="editModal"
                            max-width="900"
                            hide-overlay
                            transition="dialog-bottom-transition"
                    >
                        <v-card>
                            <v-toolbar
                                    dark
                                    color="primary"
                            >
                                <v-toolbar-title>ویرایش دسته</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn
                                            icon
                                            dark
                                            @click="editModal = false"
                                    >
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </v-toolbar-items>
                            </v-toolbar>
                            <div>
                                <create-category :modal="()=>{this.editModal = false}" v-if="editModal"
                                                 :edit_id="parent_id"></create-category>
                            </div>
                        </v-card>
                    </v-dialog>
                </v-row>
            </template>
            <!--edit category-->

            <div class="d-block mt-5">
                <v-btn v-if="directionActive ===false"
                       @click="addNewCategory = true"
                       small
                       v-status="'new_category'"
                       class="my-3 ml-3"
                       color="success" rounded outlined>
                    <i class="fa fa-plus btn-sm text-success"></i>
                    افزودن دسته
                </v-btn>

                <v-btn @click="editModal = true"
                       v-if="parent_id !== null && directionActive ===false"
                       small
                       class="my-3 ml-3"
                       color="warning"
                       v-status="'update_category'"
                       rounded
                       outlined>
                    <i class="fa fa-pencil-alt btn-sm text-warning"></i>
                    ویرایش دسته
                </v-btn>

                <v-btn @click="deleteCategory"
                       v-if="parent_id !== null && categories.filter((x)=>x.parent_id===parent_id).length === 0 && directionActive ===false"
                       small
                       class="my-3 ml-3" color="error"
                       rounded
                       v-status="'delete_category'"
                       outlined>
                    <i class="fa fa-trash-alt btn-sm text-danger"></i>
                    حذف دسته
                </v-btn>

                <v-btn @click="changeParent"
                       v-if="parent_id !== null && directionActive ===false"
                       small
                       class="my-3 ml-3" color="info"
                       rounded
                       v-status="'update_category'"
                       outlined>
                    <i class="fa fa-directions ml-2 text-primary"></i>
                    جابجایی دسته
                </v-btn>

                <v-btn @click="updateCategory"
                       v-if="directionActive === true"
                       small
                       class="my-3 ml-3" color="primary"
                       rounded
                       outlined>
                    <i class="fa fa-directions ml-2 text-info"></i>
                    ثبت دسته
                </v-btn>
            </div>

            <h1 class="text-muted text-center" v-if="categories.length<=0">هیچ دسته‌بندی وجود ندارد</h1>

            <ul style="list-style: none" class="my-5" v-else>
                <recursive-component v-if="breadCrumb.length > 0" :bread-crumb="breadCrumb"
                                     :data-back="backward"></recursive-component>
                <li style="font-size: 11.5pt;"
                    @click="parent_id=item.id;breadCrumb.push(item)"
                    class="cursor-pointer py-2 px-5"
                    v-for="item in categories.filter((x)=>x.parent_id===parent_id)"
                ><img :src="item.icon" class="img-fluid" alt="" width="30" height="30" style="border: none">
                    {{ item.title }}
                    <i class="fa fa-chevron-left float-left mr-auto my-2" style="color: #3F51B5"></i>
                </li>
            </ul>

        </div>
    </v-app>
</template>

<script>
import TitleRibbon from "../uiBeautifier/titleRibbon";
import {Axios2, Bus, dataTableProps} from "../../../main";
import Amqezi from "./recursiveComponent";
import RecursiveComponent from "./recursiveComponent";
import CreateCategory from "./createCategory";

export default {
    name: "categoryList",
    components: {CreateCategory, RecursiveComponent, Amqezi, TitleRibbon},
    data() {
        return {
            categories: [],
            directionActive: false,
            parent_id: null,
            addNewCategory: false,
            editModal: false,
            breadCrumb: [],
            resetAll: false,
            chnageId: null
        }
    },
    methods: {
        getCategory() {
            Axios2.get('/admin/category').then((response) => {
                this.categories = response.data.data;
            })
        },
        backward(item) {
            const index = this.breadCrumb.indexOf(item);

            this.parent_id = item.parent_id;

            this.breadCrumb.splice(index, this.breadCrumb.length);
        },
        deleteCategory() {
            this.$modal.yesNo('تایید حذف!', 'آیا از حذف دسته موردنظر اظمینان دارید؟', 'neg').then((value) => {
                if (value) {
                    Axios2.delete(`/admin/category/${this.parent_id}`).then((response) => {
                        this.$modal.success('موفقیت آمیز', response.data.message);
                        this.breadCrumb = [];
                        this.parent_id = null;
                        this.categories = [];
                        this.getCategory();
                    }).then((error) => {
                        this.$modal.error('خطا!', '', Object.keys(error.response.data.errors).map((key) => {
                            return error.response.data.errors[key][0]
                        }).join('\n'));
                    })
                }
            })
        },
        changeParent() {
            this.directionActive = true;
            this.chnageId = this.parent_id;
        },
        updateCategory() {
            Axios2.put(`admin/category/${this.chnageId}`, {
                "parent_id": this.parent_id,
            }).then(() => {
                this.$modal.success('موفقیت آمیز!', 'دسته موردنظر شما با موفقیت ویرایش شد');
                Bus.$emit('resetValues', true);
                this.directionActive = false

            }).catch((error) => {
                this.$modal.error('خطا!', '', Object.keys(error.response.data.errors).map((key) => {
                    return error.response.data.errors[key][0]
                }).join('\n'));
            })
        }
    },
    watch: {
        resetAll: function (value) {
            if (value === true) {
                this.breadCrumb = [];
                this.parent_id = null;
                this.categories = [];
                this.getCategory();
            }
        }
    },
    created() {
        this.getCategory();
    },
    mounted() {
        Bus.$on('resetValues', (value) => {
            this.resetAll = value
        })
    }
}
</script>

<style scoped>
.rpDesign {
    display: none;
}

li:hover .rpDesign {
    display: block;
}
</style>